const LicenseModalFormValidation = (values: any) => {
  const errors: any = {};
  if (!values.licenseId) {
    errors.licenseId = 'License ID wajib diisi';
  }
  return errors;
};

export default LicenseModalFormValidation;
